<template>
  <div>
    <div class="breadcrumb-area  pos-relative w-100">
      <h2 class="title_mo">Danh sách phiếu duyệt chi nhánh mới</h2>
    </div>
    <div class="card p-10 pt-15">
      <div class="card-header m-b-10">
        <form class="box-search search_css" @submit="submitForm">
          <div class="form-group">
            <input type="text" v-model.trim="filters.textSearch" class="form-control f12 hc-37 text-search"
              placeholder="Từ khóa" />
          </div>
          <div class="form-group">
            <input type="text" v-model.trim="filters.code" class="form-control f12 hc-37 text-search"
              placeholder="Mã phiếu" />
          </div>
          <div class="form-group">
            <input type="text" v-model.trim="filters.serial" class="form-control f12 hc-37 text-search"
              placeholder="Serial thiết bị" />
          </div>
          <div class="form-group">
            <Select2 v-model="filters.creator" :options="listUser" placeholder="Người đề xuất" />
          </div>
          <div class="form-group">
            <Select2 v-model="filters.status" :options="listStatus" placeholder="Trạng thái phiếu" />
          </div>
          <div class="form-group">
            <DateRangePicker class="w-100" :ranges="false" @update="transformDate()" v-model="dateRange"
              :locale-data="localeData">
              <template v-slot:input="picker">
                <label v-if="picker.startDate && picker.endDate" style="min-width: 13.5em"
                  class="text-center font-size-12">
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Ngày tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <Select2 v-model="filters.regionCode" :options="dataConfigRegionMC" @change="queryMcProvince($event)"
              placeholder="Vùng merchant" />
          </div>
          <div class="form-group">
            <Select2 v-model="filters.provinceCode" :options="dataProvinceMC" placeholder="Tỉnh/Thành phố"
              :disabled="!filters.regionCode || filters.regionCode === '0'" @change="getMcDistrict($event)" />
          </div>
          <div class="form-group">
            <Select2 v-model="filters.districtCode" :options="dataDistrict" placeholder="Quận/Huyện"
              :disabled="!filters.provinceCode || filters.provinceCode === '0'" />
          </div>
          <div class="form-group form-group-action search_css">
            <button @click="submitForm" class="btn btn-primary hc-37 mr-2 pt-2" data-toggle="tooltip"
              data-placement="top" title="Lọc">
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Lọc
            </button>

            <button type="button" @click="clearSearch" class="btn btn-outline-light hc-37 mr-2 pt-2"
              data-toggle="tooltip" data-placement="top" title="Bỏ lọc">
              <i class="bx bx-filter-alt"></i>
              <span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            <div class="d-flex flex-row">
              <div class="box-header list_total">
                <TotalCountCheck :totals="totalCount" :data="totals"></TotalCountCheck>
              </div>
            </div>
            <b-table bordered hover head-variant="light" fixed show-empty responsive sticky-header :items="dataTable"
              :fields="fields" :busy.sync="isLoading">
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle" />
                </div>
              </template>
              <template #empty>
                <div class="text-center text-info my-2">
                  Không có dữ liệu
                </div>
              </template>
              <template #emptyfiltered="{ emptyFilteredText }">
                <h4>{{ emptyFilteredText }}</h4>
              </template>

              <template #cell(mobile)="{ value }">
                {{ value | encryptPhone }}
              </template>

              <template #head(checkbox)>
                <b-form-checkbox v-model="selectAll" @change="toggleSelectAll" :disabled="isLoading" />
              </template>
              <template #cell(checkbox)="{ item }">
                <b-form-checkbox v-model="item.checked" />
              </template>

              <template #cell(index)="{ index }">
                {{ (pagination.page > 1) ? index + 1 + pagination.limit * (pagination.page - 1) : index + 1 }}
              </template>

              <template #cell(account)="{ item }">
                <div>{{ item.merchantName }}</div>
                <div>{{ item.merchantEmail }}</div>
                <div>{{ getAdressByCode(item) }}</div>
                <div v-if="item.merchantAccountStatus">
                  <span :class="`badge ${getAccountStatusClass(item.merchantAccountStatus)}`">
                    {{ getAccountStatusName(item.merchantAccountStatus) }}
                  </span>
                </div>
              </template>

              <template #cell(store)="{ item }">
                <div v-if="item?.storeRes"><b-link :href="`/customer-support/order-store/${item.id}`" target="_blank">{{
                  item?.storeRes?.storeName
                    }}</b-link>
                </div>
                <div v-if="item?.storeRes">
                  {{ getAdressByCode(item?.storeRes) }} <br>
                  <b-icon icon="geo-alt"></b-icon> <strong class="text-primary" style="cursor: pointer;"
                    @click="showMapModal(item?.storeRes.latitude, item?.storeRes.longitude, getAdressByCode(item?.storeRes))">{{
                      item?.storeRes?.address
                    }}</strong>
                </div>
              </template>

              <template #cell(serial)="{ item }">
                <div>{{ item?.serialDevices.join(', ') }}</div>
              </template>

              <template #cell(staff)="{ item }">
                <div>{{ item?.creator?.name }}</div>
                <div>{{ item?.creator?.email }}</div>
              </template>

              <template #cell(status)="{ item }">
                <div class="text-center" v-if="item.status || item.status != 'null'">
                  <span :class="`badge ${getStatusClass(item.status)}`">{{ getStatusName(item.status) }}</span>
                </div>
              </template>

              <template #cell(time)="{ item }">
                <div>{{ item?.createdTime | formatDate }}</div>
              </template>

              <template #head(actions)="{ label }">
                <div>{{ label }}</div>
              </template>

              <template #cell(actions)="{ item }">
                <div style="padding-left: 10px;">
                  <div>
                    <b-link :href="`/customer-support/order-store/${item.id}`" style="color: #0056F6;" size="sm"
                      target="_blank">
                      <img src="@/assets/img/circle-three-dots.svg" alt="Circle with Three Dots"
                        style="width: 15px; height: 15px;"> Chi tiết
                    </b-link>
                  </div>
                  <div>
                    <b-link :to="`/customer-support/store/${item.storeId}/edit`" v-if="checkRequestChange(item.status)"
                      style="color: #0056F6;" size="sm">
                      <i class='bx bx-edit-alt' style="width: 15px; height: 15px;"></i> Cập nhật
                    </b-link>
                  </div>
                </div>

              </template>
            </b-table>
            <div class="d-flex justify-content-end">
              <b-form-group class="mb-0" style="padding: 17px;">
                <b-form-select v-model="pagination.limit" :options="pageOptions"
                  @change="onItemsPerPageChange"></b-form-select>
              </b-form-group>
              <b-pagination v-model="pagination.page" :total-rows="totalCount" :per-page="pagination.limit"
                @change="onChangePage" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="modal-map" centered hide-footer hide-header size="lg" style="z-index: 500;">
      <div>
        <GmapMap :center="{ lat: latitude, lng: longtitude }" :zoom="12" map-type-id="terrain"
          style="width: 100%; height: 500px">
          <gmap-marker :position="{ lat: latitude, lng: longtitude }"></gmap-marker>
        </GmapMap>
      </div>
    </b-modal>
    <b-modal ref="map-address" centered hide-footer hide-header size="lg" style="z-index: 500;">
      <div>
        <iframe loading="lazy" :src="url" height="500" style="width: 100%;" frameborder="0"></iframe>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { StaffService } from '@/services/staff.service'
import Config from '@/thirdParty/config'
import { CommonService } from '@/services/common.service'
import { SearchByCode } from '@/services/customer-support/location'
import { Filter } from '@/services/customer-support/order-store'
import { showMess } from '@/config/utils'
import moment from 'moment'
import TotalCountCheck from '@/components/cskh/Counts.vue'
export default {
  components: {
    TotalCountCheck
  },
  data() {
    return {
      filters: {
        textSearch: '',
        code: '',
        serial: '',
        regionCode: '',
        provinceCode: '',
        districtCode: '',
        creator: '',
        status: '',
      },
      latitude: 0.0,
      longitude: 0.0,
      url: '',
      isLoading: true,
      dataConfigRegion: [],
      dataConfigRegionMC: [],
      dataProvinceMC: [],
      dataProvince: [],
      dataDistrict: [],
      dataDistrictName: [],
      dataConfigMcc: [],
      listUser: [],
      userId: JSON.parse(localStorage.getItem('userData')).userId,
      totalCount: 0,
      // config
      dataConfigService: [],
      sourceCreate: Config.sourceCreate,
      localeData: Config.localeData,
      ownershipType: [], // systemConfig.ownershipType,
      listAccountStatus: [],

      listStatus: [
        { id: 0, text: 'Tất cả' },
        { id: 'PENDING_SA_APPROVAL', text: 'Chờ SA duyệt', name: 'Chờ SA duyệt', bgColor: 'badge-warning', class: 'text-warning' },
        { id: 'PENDING_VH_APPROVAL', text: 'Chờ VH duyệt', name: 'Chờ VH duyệt', bgColor: 'badge-warning', class: 'text-warning' },
        { id: 'SA_REQUESTED_CHANGES', text: 'SA yêu cầu sửa', name: 'SA yêu cầu sửa', bgColor: 'badge-info', class: 'text-info' },
        { id: 'VH_REQUESTED_CHANGES', text: 'VH yêu cầu sửa', name: 'VH yêu cầu sửa', bgColor: 'badge-info', class: 'text-info' },
        { id: 'SA_REJECTED', text: 'SA từ chối', name: 'SA từ chối', bgColor: 'badge-danger', class: 'text-danger' },
        { id: 'VH_REJECTED', text: 'VH từ chối', name: 'VH từ chối', bgColor: 'badge-danger', class: 'text-danger' },
        { id: 'SUCCESS', text: 'VH duyệt', name: 'VH duyệt', bgColor: 'badge-success', class: 'text-success' },
      ],
      fields: [
        {
          key: 'index',
          label: 'STT',
          class: 'text-center',
          thStyle: 'width: 30px; text-align: center',
        },
        {
          key: 'code',
          label: 'Mã phiếu',
          sortable: false,
          class: 'text-center'
        },
        {
          key: 'account',
          label: 'Thông tin MA',
          sortable: false,
          thStyle: 'min-width: 150px, max-width: 200px',
          tdClass: 'td_class'
        },
        {
          key: 'store',
          label: 'Thông tin cửa hàng',
          sortable: false,
          thStyle: 'min-width: 100px',
          tdClass: 'owner_class'
        },
        {
          key: 'serial',
          label: 'Serial thiết bị',
          sortable: false,
          thStyle: 'min-width: 100px',
          tdClass: 'address_class'
        },
        {
          key: 'staff',
          label: 'Người đề xuất( NVCS lên PLHĐ)',
          sortable: false,
          thStyle: 'min-width: 150px, max-width: 200px',
          tdClass: 'td_class'
        },
        {
          key: 'time',
          label: 'Ngày tạo',
          sortable: false,
          class: 'text-center',
          thStyle: 'min-width: 80px, max-width: 150px',
        },
        {
          key: 'status',
          label: 'Trạng thái',
          sortable: false,
          thStyle: 'min-width: 100px; max-width: 150px;',
          class: 'text-center '
        },
        {
          key: 'actions',
          label: 'Thao tác',
          sortable: false,
          class: 'text-center',
          thStyle: 'min-width: 80px',
        }
      ],
      pagination: {
        queryString: '',
        sortField: 'createdDate',
        sortType: 'DESC',
        sortResultType: 'ASC',
        page: 1,
        total: 0,
        limit: 20,
      },
      totals: {},
      dataTable: [],
      dateRange: {
        startDate: null,
        endDate: null
      },
      pageOptions: [
        { value: 20, text: '20/trang' },
        { value: 50, text: '50/trang' },
        { value: 100, text: '100/trang' },
        { value: 200, text: '200/trang' },
      ],
    }
  },
  async mounted() {
    await this.configSystem()
    if (this.dataPermission.includes('CNPS_CSS_ORDER_STORE_VIEW')) {
      await this.getRegions()
      await this.getListStaffBySuperior()
      await this.buildQuery()
      await this.getMcRegions()
      await this.getManager()
      this.isLoading = false
    } else {
      this.$bvModal.msgBoxOk('Bạn không có quyền truy cập vào trang này', {
        title: 'Cảnh báo',
        okVariant: 'danger',
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true,
      })
        .then(() => {
          this.$router.replace('/');
        })
    }
  },

  created() {
  },
  computed: {
    ...mapGetters({
      dataPermission: 'role/dataPermission',
    }),
    getStatusName() {
      return (status) => {
        const objStatus = this.listStatus.find(s => s.id === status);
        return objStatus ? objStatus.text : status
      }
    },
    getStatusClass() {
      return (status) => {
        const objStatus = this.listStatus.find(s => s.id === status);
        return objStatus ? objStatus.bgColor : 'badge-primary'
      }
    },
    checkRequestChange() {
      return (status) => {
        const objStatus = ['SA_REQUESTED_CHANGES', 'VH_REQUESTED_CHANGES'];
        return objStatus.includes(status)
      }
    },

    getAccountStatusName() {
      return (status) => {
        const objStatus = this.listAccountStatus.find(s => s.id === status);
        return objStatus ? objStatus.text : status
      }
    },
    getAccountStatusClass() {
      return (status) => {
        const objStatus = this.listAccountStatus.find(s => s.id === status);
        return objStatus ? objStatus.bgColor : 'badge-primary'
      }
    },
  },
  methods: {
    openInGoogleMaps(address) {
      // const url = `https://www.google.com/maps/search/api=1&query=${encodeURIComponent(address)}`;
      // window.open(url, '_blank');
      const url = `https://maps.google.com/maps?q=${address}&output=embed`;
      this.url = url
      this.$refs['map-address'].show()
    },
    openInGoogleMapsLatLng(lat, lng) {
      const url = `https://www.google.com/maps?q=${lat},${lng}`;
      window.open(url, '_blank');
    },
    onItemsPerPageChange() {
      this.pagination.page = 1; // Reset về trang 1 khi thay đổi số mục mỗi trang
      this.refreshTable()
    },
    refreshTable() {
      this.buildQuery();
    },
    // nút bỏ lọc
    async clearSearch() {
      this.selectAll = false
      this.pagination.page = 1
      this.filters.textSearch = ''
      this.filters.code = ''
      this.filters.serial = ''
      this.search = ''
      this.filters.regionCode = ''
      this.filters.provinceCode = ''
      this.filters.districtCode = ''
      this.filters.status = ''
      this.filters.creator = ''
      this.filters.startDate = ''
      this.filters.endDate = ''
      this.dateRange = {
        startDate: null,
        endDate: null
      }
      this.dataProvinceMC = []
      this.dataDistrict = []
      await this.buildQuery()
    },
    transformDate() {
      this.filters.startDate = moment(this.dateRange.startDate).startOf('day').add(7, 'hours').valueOf()
      this.filters.endDate = moment(this.dateRange.endDate).endOf('day').add(7, 'hours').valueOf()
    },
    async buildQuery() {
      // const conditions = [];
      const conditionsMap = {};

      const textSearch = this.filters.textSearch?.trim();
      textSearch && (conditionsMap.keyWord = textSearch);
      const code = this.filters.code?.trim();
      code && (conditionsMap.code = code);
      const serial = this.filters.serial?.trim();
      serial && (conditionsMap.serial = serial);
      this.filters.creator && this.filters.creator !== '0' && (conditionsMap.creatorId = this.filters.creator);
      this.filters.status && this.filters.status !== '0' && (conditionsMap.status = this.filters.status);
      this.filters.regionCode && this.filters.regionCode !== '0' && (conditionsMap.regionId = this.filters.regionCode);
      this.filters.provinceCode && this.filters.provinceCode !== '0' && (conditionsMap.provinceCode = this.filters.provinceCode);
      this.filters.districtCode && this.filters.districtCode !== '0' && (conditionsMap.districtCode = this.filters.districtCode);
      this.filters.startDate && this.filters.startDate !== '' && (conditionsMap.createdDateFrom = this.filters.startDate);
      this.filters.endDate && this.filters.endDate !== '' && (conditionsMap.createdDateTo = this.filters.endDate);

      await this.loadData(conditionsMap);
    },
    async loadData(conditionsMap = {}) {
      try {
        this.isLoading = true;
        const searchQuery = {
          limit: this.pagination.limit,
          page: this.pagination.page,
          ...conditionsMap,
          sort: {
            direction: this.pagination.sortType,
            properties: [this.pagination.sortField],
          },
        };
        const res = await Filter(searchQuery);
        if (res.data.list) {
          this.dataTable = res.data.list.map(el => {
            return {
              ...el,
              checked: false,
            }
          });
        } else {
          this.dataTable = []
        }
        this.pagination.total = res.data.count ?? 0;
        this.totalCount = res.data.count ?? 0;
        if (res.data.countMap) {
          const filteredListStatus = this.listStatus.filter(status => status.id !== 0);
          const updatedListStatus = filteredListStatus.map(status => {
            const count = res.data.countMap[status.id] || 0;
            return {
              status: status.text || status.id,
              status_class: status.class ?? 'text-primary',
              count: count
            };
          });
          this.totals = updatedListStatus
        } else {
          this.totals = []
        }
      } catch (e) {
        showMess(this, 'Error', e.message, 'danger', 'b-toaster-top-right', 5 * 60 * 60)
      } finally {
        this.isLoading = false;
      }
    },
    async onChangeAccount(e) {
      await this.loadDataContact(e);
    },
    showMapModal(lat, long, address) {
      if (lat && long) {
        this.latitude = (Number.isInteger(this.latitude)) ? lat : parseFloat(lat)
        this.longtitude = (Number.isInteger(this.longtitude)) ? long : parseFloat(long)
        this.$refs['modal-map'].show()
      } else {
        this.url = `https://maps.google.com/maps?q=${address}&output=embed`;
        this.$refs['map-address'].show()
      }
    },
    getAdressByCode(item) {
      const addressArr = []
      if (item.districtName) { addressArr.push(item.districtName) }
      if (item.provinceName) { addressArr.push(item.provinceName) }
      if (item.regionName) { addressArr.push(item.regionName) }
      return (addressArr.length > 0) ? addressArr.join(', ') : item.address
    },
    async submitForm(event) {
      event.preventDefault()
      this.selectAll = false
      this.pagination.page = 1
      this.buildQuery()
    },
    // page
    onChangePage(pageIndex) {
      this.pagination.page = pageIndex;
      this.buildQuery();
    },
    onDetailClick(item) {
      this.$router.push(`/customer-support/order-store/${item.id}`);
    },
    // lấy vùng
    async getRegions() {
      const data = await StaffService.getRegions()
      if (data.data.length > 0) {
        this.dataConfigRegion = data.data.map(e => {
          return {
            id: e.id,
            text: e.name
          }
        })
        this.dataConfigRegion.unshift({ id: '0', text: 'Tất cả' })
      }
    },
    // lấy tỉnh, tp
    async queryProvince(e) {
      try {
        this.filters.businessProvinceCode = ''
        this.dataProvince = []
        const data = await StaffService.getProvinceRegion({ regionId: [e] })
        if (data.data.length > 0) {
          this.dataProvince = data.data.map(e => {
            return {
              id: e.id,
              text: e.name
            }
          })
          this.dataProvince.unshift({ id: '0', text: 'Tất cả' })
        }
      } catch (error) { }
    },
    // lấy vùng mc
    async getMcRegions() {
      const data = await StaffService.getRegions()
      if (data.data.length > 0) {
        this.dataConfigRegionMC = data.data.map(e => {
          return {
            id: e.id,
            text: e.name,
            // idRegion: e.id
          }
        })
        this.dataConfigRegionMC.unshift({ id: '0', text: 'Tất cả' })
      }
    },
    // lấy tỉnh, tp mc
    async queryMcProvince(e) {
      try {
        this.filters.provinceCode = ''
        this.filters.districtCode = ''
        // [this.dataConfigRegionMC.find(s => s.id === e).idRegion]
        const data = await StaffService.getProvinceRegion({ regionId: [e] })
        if (data.data.length > 0) {
          this.dataProvinceMC = data.data.map(e => {
            return {
              id: e.code,
              text: e.name
            }
          })
          this.dataProvinceMC.unshift({ id: '0', text: 'Tất cả' })
        }
      } catch (error) { }
    },
    // lấy quận mc
    async getMcDistrict(event) {
      this.filters.districtCode = ''
      const data = await SearchByCode({ code: event })
      if (data.data.length > 0) {
        this.dataDistrict = data.data
          .sort((a, b) => a.locationCode.localeCompare(b.locationCode))
          .map(e => {
            return {
              id: e.locationCode,
              text: e.localName
            }
          })
      }
      this.dataDistrict.unshift({ id: '0', text: 'Tất cả' })
    },
    // Lấy danh sách nhân viên
    async getListStaffBySuperior() {
      try {
        const data = await StaffService.getStaffByIdSuperior({
          userId: this.userId
        })
        if (data.data.length > 0) {
          this.listUser = data.data.map((e) => {
            return {
              id: e.userId,
              text: `${e.name} - ${e.userName}`
            }
          })
          this.listUser.unshift({ id: '0', text: 'Tất cả' })
        }
      } catch (error) {
        console.log(error)
      }
    },
    // Lấy quản lý
    async getManager() {
      try {
        const data = await StaffService.superiors()
        if (data.success) {
          this.dataManager = data.data.map(e => {
            return {
              id: e.id,
              text: `${e.name} - ${e.userName}`
            }
          })
          this.dataManager.unshift({ id: '0', text: 'Tất cả' })
        }
      } catch (error) {
        console.log(error)
      }
    },
    // lấy ngành hàng và dịch vụ
    configSystem() {
      return CommonService.getConfigSystem()
        .then((data) => {
          if (data.success) {
            this.optionsTypeAssign = data.data.typeAssign.map(item => {
              return {
                id: item.code,
                text: item.name
              }
            })
            this.listAccountStatus = data.data.merchantAccountStatus.map((e) => {
              return {
                ...e,
                id: e.code,
                text: e.name
              }
            })
          }
        })
        .catch((error) => console.error(error))
    },
  },
}
</script>
<style scoped>
.total_check {
  /* margin: 5px; */
  /* text-align: center; */
  display: flex;
  text-align: center;
}

.total_label {
  color: #8A9298;
  font-size: 14px;
}

.total_field {
  font-size: 20px;
}
</style>
<style>
.td_class {
  min-width: 150px;
  max-width: 200px;
}

.time_class {
  min-width: 100px;
  max-width: 150px;
}

.nowrap {
  white-space: nowrap;
}

.tooltip-class .tooltip-inner {
  background-color: rgb(253, 253, 253);
  color: #319DB5;
  text-align: left;
  max-height: 150px;
  max-width: 200px;
  overflow-y: auto;
  border: 1px solid
}

.b-table tbody tr {
  font-size: 12px;
  font-weight: 400;
  line-height: 14.06px;
  text-align: left;
}

.b-table thead tr {
  font-size: 13px;
  font-weight: 500;
  line-height: 15.23px;
  text-align: left;

}

.title_mo {
  font-size: 20px;
  font-weight: 400;
  line-height: 23.44px;
  text-align: left;
}

.list_total {
  font-size: 13px;
  font-weight: 400;
  line-height: 15.23px;
  text-align: left;
}

.search_css {
  font-size: 12px;
  font-weight: 400;
  line-height: 14.06px;
  text-align: left;
}
</style>
<style>
.address_class {
  min-width: 100px;
  max-width: 220px;
}

.owner_class {
  min-width: 120px;
  max-width: 220px;
}

.business_type_class {
  min-width: 100px;
  max-width: 180px;
}

.status_class {
  min-width: 100px;
  max-width: 120px;
}

.select2-dropdown {
  z-index: 1030 !important;
}
</style>
